<!-- Full screen loading spinner when loading -->
 <ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="large"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
</ngx-spinner>
 
<div class="main-container">
  <div *ngIf="!isLoading && !isInCallback" class="flex flex-row justify-between items-center gap-4 site-header">
    <div class="flex items-center gap-3">
      <img class="header-logo w-[124.5px] h-[36px]" src="assets/logos/Verisk-logo.png">
      <p class="header-title truncate text-white px-4.5 py-4.5">Casualty Solutions Portal</p>
    </div>

   <div class="flex items-center mr-8">
   <div class="notification-icon border-r-[1px] border-r-[#2A7DE1] border-solid pr-10">
      <app-notification></app-notification>
    </div>
    <div
      #profileWrapper
      class="height-[44px] flex items-center flex-end ml-8 gap-2 relative cursor-pointer"
      (click)="toggleProfileDropdown($event)"
      aria-label="Profile menu">
      <img src="assets/logos/Person-icon.svg">
      <p class="text-white pl-2" style="font-family:roboto">Welcome, {{userName.split(' ')[0]}}
        <br><b>Viewer</b>
      </p>
      <lucide-icon name="chevron-down" class="text-white self-start mt-[2px] w-5 h-5"></lucide-icon>

      <div
        *ngIf="profileDropdownOpen"
        class="absolute right-0 top-full mt-2 w-[160px] bg-white border border-gray-200 rounded-md shadow-lg z-50"
        (click)="$event.stopPropagation()"
      >
        <button
          type="button"
          class="w-full text-left px-4 py-2 text-sm text-[#00358E] hover:bg-gray-50"
          (click)="onSignOutClick($event)"
        >
          Sign out
        </button>
      </div>
    </div>
    </div>
 
     </div>
         <div *ngIf="(isHome || !userName) else notHomeHeader" class="home-text-header flex flex-col items-center gap-[12px]">
        <div *ngIf="userName else loading" class="home-header-text text-3xl mb-2 mt-8 text-center">Welcome {{ userName }}</div>
        <ng-template #loading>
            <div class="home-header-text mb-2 mt-8 text-center">Loading...</div>
        </ng-template>
        <div class="font-sans text-base font-medium leading-6 tracking-wide mb-8 text-center text-white">Please select an area to continue:</div>
    </div>
    <ng-template #notHomeHeader>
      <div class="home-text-header flex flex-row items-center justify-between pl-[30px] pr-[30px]">
        <div class="flex flex-col items-start justify-center gap-[2px]">
          <div class="home-header-text font-normal leading-[40px] tracking-0 text-3xl">{{breadcrumbItems[0]?.label}}</div>
          <div class="font-sans text-base font-light leading-6 tracking-wide flex items-center text-center text-white">
             <li oriBreadcrumItem class="flex-shrink-0 list-none">
                <a oriBreadcrumbLink class="flex flex-row gap-2 items-center" routerLink="/home">
                  <lucide-icon [img]="Home" class="w-4 h-4"></lucide-icon>
                  <span class="hidden sm:inline">Home</span>
                </a>              
            </li>
            @for (item of breadcrumbItems; track $index) {
                <li oriBreadcrumbSeparator class="flex-shrink-0 mt-1 list-none"></li>
                <li oriBreadcrumbItem class="min-w-0 h-4 flex-1 max-w-fit list-none">
                  @if (item.route) {
                    <a oriBreadcrumbLink [routerLink]="item.route" class="truncate block">{{ item.label }}</a>
                  } @else {
                    <span class="truncate block">{{ item.label }}</span>
                  }
                </li>
              }
          </div>
        </div>

        <div *ngIf="isReferralsPage" class="flex items-center gap-4">
          <span
            *ngIf="exportButtonVisible"
            [title]="exportButtonTooltip"
          >
            <button
              type="button"
              [disabled]="exportButtonDisabled"
              (click)="onExportReferralsClick()"
              class="bg-white text-[#00358E] px-4 py-2 rounded-full font-semibold flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
              [ngClass]="exportButtonDisabled ? 'bg-[#e7e7e7]' : 'bg-white hover:bg-[#e7e7e7]'"
            >
              <ng-container *ngIf="!isExportingReferrals; else referralExportingTpl">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V3"></path>
                </svg>
                Export
              </ng-container>
              <ng-template #referralExportingTpl>
                <span class="flex items-center gap-2">
                  <span class="inline-block w-4 h-4 border-2 border-[#00358E] border-t-transparent rounded-full animate-spin"></span>
                  Exporting...
                </span>
              </ng-template>
            </button>
          </span>

          <div class="last-refreshed text-right text-white mr-2">
            <div class="last-refreshed-label">Last refreshed</div>
            <div class="last-refreshed-value">{{ referralsLastRefreshed }}</div>
          </div>
        </div>

        <!-- Export Data Button (visible only on Client Dashboard) -->
        <div *ngIf="isClientDashboard" class="flex items-center">
          <button 
            (click)="exportClientData()" 
            [disabled]="isExporting || !clientId"
            class="bg-white text-[#00358E] px-4 py-2 rounded-full font-semibold flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
            [ngClass]="(isExporting || !clientId) ? 'bg-[#e7e7e7]' : 'bg-white hover:bg-[#e7e7e7]'">
            <ng-container *ngIf="!isExporting; else exportingTpl">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V3"></path>
              </svg>
              Export Data
            </ng-container>
            <ng-template #exportingTpl>
              <span class="flex items-center gap-2">
                <span class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                Exporting...
              </span>
            </ng-template>
          </button>
        </div>
      </div>
        
    </ng-template>


  <div class="router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</div>
 <footer class="flex justify-between bg-[#00358E] h-12 items-center">
    <p class="text-[12px] w-[688px] font-normal text-white ml-6">Verisk® is a registered trademark of Verisk Analytics, Inc.</p>
    <p class="text-[12px] font-normal text-white mr-6">All rights are reserved</p>
  </footer>